import { withProps } from 'recompose'
import { TRAILER_TYPE, TRAILER_RV_ATV_TYPE } from 'constant'

export default withProps(({ vehicleType }) => ({
  isTrailer: vehicleType === TRAILER_TYPE,
  isGenericTrailer: vehicleType === TRAILER_RV_ATV_TYPE
}))
